import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useMutation, useQuery } from "convex/react";
import { useEffect } from "react";
import { z } from "zod";
import { AppShell } from "@/components/app-shell";
import { LoadingScreen } from "@/components/loading-screen";
import { api } from "@/lib/convex-api";

export const Route = createFileRoute("/_authenticated")({
  // AppShell (layout) manipulates `cmdk` + `modal` search params regardless of
  // which authenticated child route is currently active.
  validateSearch: z.object({
    cmdk: z.literal("1").optional(),
    modal: z
      .enum(["org_settings", "user_settings", "project_settings"])
      .optional(),
  }),
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const user = useQuery(api.users.me);
  const ensureOrganization = useMutation(
    api.organizations.getOrCreateDefaultOrganization,
  );

  useEffect(() => {
    if (!user) return;
    void ensureOrganization({});
  }, [ensureOrganization, user]);

  if (user === undefined) {
    return <LoadingScreen />;
  }
  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
